import { RESOURCES_CONSTANTS } from "config/constants";

const { RESERVATION_TYPES } = RESOURCES_CONSTANTS;

export const SPACE_RESERVATIONS_KEYS = Object.freeze({
	[RESERVATION_TYPES.REGULAR]: "reservations",
	[RESERVATION_TYPES.MANUAL]: "adminReservations"
});